<template>
  <div id="hero-box" class="bg-red rounded align-stretch container">
    <div class="hero-container-images w-50 bg-white rounded text-align-center">
        <img
        v-if="hasBannerUrl"
        class="max-w-images-banner border-radius-10"
        :src="bannerImageSrc"
        alt="sponsor partner logo"
      />
      <div v-else>
          <img
            class="max-w-images mb-30"
            src="../../../images/project-img/Logo_quotazioni.png"
            alt=""
            width="300"
          />
          <div class="text-align-center text-gray fw-bold mb-30">Offerta da:</div>
          <img src="../../../images/project-img/logo_generali.png" alt="Logo Quotazioni Sponsorizzate Quattroruote" width="230px" />
      </div>
    </div>
    <div class="hero-text-white md-width-50">
        <div v-if="hasBannerText" v-html="bannerText"></div>
        <div v-else>
            <h2 class="">Prodotto Promozione* lorem ipsum</h2>
            <p class="">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
              labore et dolore magna aliqua. Ut enim ad minim veniam
            </p>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HeroBoxSponsor',
  props: {
    type: {
      type: String,
      required: false,
    },
    banner: {
      type: Object,
      default: () => ({ banner_text: '', banner_url: '' }),
    },
  },
  computed: {
    bannerData() {
      return this.banner && this.banner.banner ? this.banner.banner : this.banner;
    },
    hasBannerUrl() {
      return (
        this.bannerData && this.bannerData.banner_url && this.bannerData.banner_url.trim() !== ''
      );
    },
    bannerImageSrc() {
      return this.hasBannerUrl ? '/storage/' + this.bannerData.banner_url : this.imageSrc;
    },
    // Verifica se è presente un banner_text che non sia vuoto o solo "<p><br></p>"
    hasBannerText() {
      return (
        this.bannerData &&
        this.bannerData.banner_text &&
        this.bannerData.banner_text.trim() !== '' &&
        this.bannerData.banner_text.trim() !== '<p><br></p>'
      );
    },
    bannerText() {
      return this.hasBannerText ? this.bannerData.banner_text : '';
    },
  },
}
</script>

<style scoped>
@media (max-width: 768px) {
    .hero-container-images {
        width: 100%;
    }
}
.border-radius-10 {
  border-radius: 10px;
}
.p-0 {
  padding: 0;
}
.justify-content-between {
  justify-content: space-between !important;
}
.mr-3 {
  margin-right: 3rem;
}
.max-w-images-banner {
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// resources/js/app/components/HeroBoxSponsor.vue